/** @format */
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Attainment, CreditRange, CustomModuleAttainment, LocalizedString, Module, OtmId } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { CustomModuleAttainmentStateObject, PlanData, PlanStateObject } from '../../../service/plan-state.service';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-rule-custom-module-attainment-box',
    templateUrl: './rule-custom-module-attainment-box.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class RuleCustomModuleAttainmentBoxComponent implements OnInit {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.plan.rules.ruleCustomModuleAttainmentBox',
        directiveName: 'sisRuleCustomModuleAttainmentBox',
    };

    customModuleAttainmentStateObject: CustomModuleAttainmentStateObject;
    attainment: Attainment;
    visibleCredits: CreditRange;
    gradeAbbreviation: LocalizedString;
    showExpiryWarning: boolean;
    dimmed = false;

    @Input() customModuleAttainment: CustomModuleAttainment;
    @Input() planValidationResult: any;
    @Input() planStateObject: PlanStateObject;
    @Input() planData: PlanData;
    @Input() isImplicit: boolean;
    @Input() parentModule?: Module;
    @Input() substitutedCourseUnitId?: OtmId;

    ngOnInit() {
        if (this.customModuleAttainment) {
            this.showExpiryWarning = true;
            this.customModuleAttainmentStateObject = _.get(this.planStateObject.customModuleAttainments, this.customModuleAttainment.id);
        }
    }

    openModuleInfoModal() {}
}
